import { constants, getCurrSection, getIsEndBoardZoomed, getItemsInCart, setItemsInCart } from "../model"
import EventBus from "eventing-bus"

const viewEl = document.querySelector("#credits-btn-view"),
  btn = viewEl.querySelector(".credits-btn")

const handleSectionChanged = () => {
  viewEl.classList.add("show")
}

const handleClick = () => {
  EventBus.publish(constants.CART_BTN_PRESSED)
}
btn.addEventListener("click", handleClick)

EventBus.on(constants.SECTION_CHANGED, handleSectionChanged)
